import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { useScopedRouteContext } from "../../authRouterHelpers";
import { rootRoute } from "../__root";

const LazySignUpPage = lazyRouteComponent(
  () =>
    import(
      /* webpackChunkName: "DiscoverSignUpPage" */ "@circle-react/components/Discover/SignUpPage"
    ),
  "SignUpPage",
);

const DiscoverSignUpRoute = () => {
  const { hasEmail = false } = useScopedRouteContext({ from: rootRoute.id });

  return <LazySignUpPage hasEmail={hasEmail} />;
};

export const userSignUpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/user/sign_up",
  component: DiscoverSignUpRoute,
});
